import React, { ComponentProps } from 'react';
import { Button, Icon } from '@common/components';

export function AddButton({
  children,
  showDropdown = false,
  ...props
}: Omit<ComponentProps<typeof Button>, 'icon' | 'iconRight'> & {
  showDropdown?: boolean;
}) {
  return (
    <Button
      size="md"
      {...props}
      icon={<Icon icon="plus" kind="light" />}
      iconRight={
        showDropdown ? (
          <Icon
            icon="chevronDown"
            size="sm"
            kind="regular"
            color="steelDarker"
          />
        ) : undefined
      }
    >
      {children}
    </Button>
  );
}
